/* src/pages/Resources.js (Updated with Global Search) */
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const resourceCategories = [
    { name: 'Articles', description: 'Read expert advice and tips.', icon: 'article', path: '/articles' },
    { name: 'Videos', description: 'Watch helpful videos and tutorials.', icon: 'videocam', path: '/videos' },
    { name: 'Reels', description: 'Quick tips and short-form video content.', icon: 'video_library', path: '/reels' },
    { name: 'Podcasts', description: 'Listen to inspiring stories & talks.', icon: 'headphones', path: '/podcasts' }
];

const Resources = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (searchTerm.trim()) {
            navigate(`/search?q=${searchTerm.trim()}`);
        }
    };

    return (
        <div className="resource-list">
            <form onSubmit={handleSearchSubmit}>
                <div className="search-bar-container">
                    <span className="material-icons search-icon">search</span>
                    <input
                        type="search"
                        placeholder="Search all content..."
                        className="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </form>

            {resourceCategories.map((category, index) => (
                <Link to={category.path} key={index} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div className="resource-card">
                        <div className="resource-icon-container" style={{ backgroundColor: '#1abc9c' }}>
                            <span className="material-icons">{category.icon}</span>
                        </div>
                        <div className="resource-text">
                            <h3>{category.name}</h3>
                            <p>{category.description}</p>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    );
};

export default Resources;
